import { ILayoutState, ModalVisibilityAction } from './types';
import { createSlice } from '@reduxjs/toolkit';
import { AppThunk } from '../index';

const initialState: ILayoutState = {
  mainLoading: {
    status: false,
    counter: 0,
  },
  modals: {
    // We can open these modal from different places, that`s why i moved visibility states in store
    isLoginModalOpened: false,
  },
};

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    startMainLoading(state) {
      state.mainLoading.counter += 1;
      state.mainLoading.status = true;
    },
    stopMainLoading(state) {
      const operationsCount = state.mainLoading.counter;
      if (operationsCount === 1) {
        state.mainLoading.counter = 0;
        state.mainLoading.status = false;
      } else if (operationsCount > 1) {
        state.mainLoading.counter -= 1;
      }
    },

    setLoginModalVisibility(state, action: ModalVisibilityAction) {
      state.modals.isLoginModalOpened = action.payload.status;
    },
  },
});

export const { startMainLoading, stopMainLoading, setLoginModalVisibility } =
  layoutSlice.actions;

export const closeLoginModal =
  (): AppThunk =>
  (dispatch): void => {
    dispatch(setLoginModalVisibility({ status: false }));
  };
export const openLoginModal =
  (user:any): AppThunk =>
  (dispatch): void => {
    localStorage.setItem('userType', user);
    dispatch(setLoginModalVisibility({ status: true }));
  };
export const layoutReducer = layoutSlice.reducer;
